import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Userpilot } from 'userpilot';

/**
 * Tracks route changes and reloads Userpilot
 * to ensure that page path is pushed correctly to Userpilot
 */
const UserpilotRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    Userpilot.reload();
  }, [location.pathname]);

  return null;
};

export default UserpilotRouteTracker;

